import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/buttons/app-store-button.png'
import _imports_1 from '@/assets/icons/buttons/google-play-button.png'


const _withScopeId = n => (_pushScopeId("data-v-5ace0658"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "download-cta",
  "aria-labelledby": "download-cta-title"
}
const _hoisted_2 = {
  class: "download-cta-inner",
  dir: "auto"
}
const _hoisted_3 = { id: "download-cta-title" }
const _hoisted_4 = { class: "stores" }
const _hoisted_5 = ["href", "aria-label"]
const _hoisted_6 = ["alt"]
const _hoisted_7 = ["href", "aria-label"]
const _hoisted_8 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t('home.downloadCta.title')), 1),
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('home.downloadCta.desc')), 1),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("a", {
          href: _ctx.getStoreLink('appStore'),
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": _ctx.$t('navigation.navbar.subpages.appStore')
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: _ctx.$t('navigation.navbar.subpages.appStore')
          }, null, 8, _hoisted_6)
        ], 8, _hoisted_5),
        _createElementVNode("a", {
          href: _ctx.getStoreLink('googlePlay'),
          target: "_blank",
          rel: "noopener noreferrer",
          "aria-label": _ctx.$t('navigation.navbar.subpages.googlePlay')
        }, [
          _createElementVNode("img", {
            src: _imports_1,
            alt: _ctx.$t('navigation.navbar.subpages.googlePlay')
          }, null, 8, _hoisted_8)
        ], 8, _hoisted_7)
      ])
    ])
  ]))
}